import React, { useCallback, useEffect, useState } from 'react';
import { Alert, TextField, MenuItem, Button } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import {
  API_GET_STUDENTS,
  API_ADD_MISC_FEE,
  API_GET_FEES_BOOKS_MASTER,
  API_UPDATE_MISC_FEE   
} from "../Config/ApiUrlConstant";
import { useAuth } from "../AuthContext";
import { ClassListArray } from "../Common/Component/CommonComponents";
const getCurrentSession = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  return month >= 4
    ? `${year}-${(year + 1).toString().slice(-2)}`
    : `${year - 1}-${year.toString().slice(-2)}`;
};

const getSessionOptions = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  const startYear = month >= 4 ? year : year - 1;

  const sessions = [];
  for (let i = -2; i <= 1; i++) {
    const y = startYear + i;
    const next = (y + 1).toString().slice(-2);
    sessions.push(`${y}-${next}`);
  }

  return sessions.reverse(); // latest first
};
const amountFields = ['book_paid_amt', 'lower_tshirt_paid_amt', 'annual_promotion_amt', 'admission_amt', 'diary_id_tie_belt_amt', 'misc_pending', 'discount'];
const normalizedAmounts = (data) => Object.fromEntries(Object.entries(data).map(([key, value]) => [key, amountFields.includes(key) && (value === '' || value === null || value === undefined) ? 0 : value]));
const AddEditOtherMiscFee = ({ onSuccess, initialData }) => {
  const [formData, setFormData] = useState({
    id: null,
    student_id: '',
    class_no: '',
    session: getCurrentSession(),
    book_paid_amt: '',
    lower_tshirt_paid_amt: '',
    annual_promotion_amt: '',
    admission_amt: '',
    diary_id_tie_belt_amt: '',
    misc_pending: 0,
    description: '',
    discount: 0,
    is_active: true,
    created_at: new Date().toISOString().split('T')[0]
  });

  const [message, setMessage] = useState('');
  const [feesBooks, setFeesBooks] = useState([]);
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const { logout } = useAuth();
  const sessions = getSessionOptions();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invalidField = amountFields.find((field) => {
      const value = formData[field];
      return value !== '' && value !== null && value !== undefined && (!Number.isFinite(Number(value)) || Number(value) < 0);
    });
    if (invalidField) {
      setMessage('All fee amounts must be valid non-negative numbers.');
      return;
    }

    const isEdit = !!formData.id;
    const apiUrl = isEdit ? API_UPDATE_MISC_FEE : API_ADD_MISC_FEE;
    const method = "POST";

    try {
      const token = localStorage.getItem('school_token');
      const response = await fetch(apiUrl, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(normalizedAmounts(formData)),
      });

      const responseData = await response.json();

      if (response.status === 401 || response.status === 403) {
        logout();
        return;
      }

      if (response.ok && responseData.status) {
        const successMessage = responseData.message || (isEdit ? 'Miscellaneous fee updated.' : 'Miscellaneous fee saved.');
        setMessage('');
        resetForm();
        if (onSuccess) onSuccess(successMessage);
      } else {
        setMessage(responseData.message || 'Something went wrong.');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('Error saving misc fee.');
    }
  };

  const getAllStudents = useCallback(async () => {
    try {
      const token = localStorage.getItem("school_token");
      const response = await fetch(API_GET_STUDENTS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401 || response.status === 403) {
        logout();
        return;
      }

      const responseData = await response.json();
      setStudents(responseData.data || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  }, [logout]);

  const resetForm = () => {
    setFormData({
      id: null,
      student_id: '',
      class_no: '',
      session: getCurrentSession(),
      book_paid_amt: '',
      lower_tshirt_paid_amt: '',
      annual_promotion_amt: '',
      admission_amt: '',
      diary_id_tie_belt_amt: '',
      misc_pending: 0,
      description: '',
      discount: 0,
      is_active: true,
      created_at: new Date().toISOString().split('T')[0]
    });
  };

  const getAllFeesBooksMaster = useCallback(async () => {
    try {
      const token = localStorage.getItem("school_token");
      const response = await fetch(API_GET_FEES_BOOKS_MASTER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401 || response.status === 403) {
        logout();
        return;
      }

      const responseData = await response.json();
      setFeesBooks(responseData.data || []);
    } catch (error) {
      console.error("Error fetching feesBooks:", error);
    }
  }, [logout]);

  useEffect(() => {
    getAllStudents();
    getAllFeesBooksMaster();
  }, [getAllStudents, getAllFeesBooksMaster]);

  useEffect(() => {
    if (!formData.class_no) return;

    const filteredStudents = students.filter(s => String(s.class) === String(formData.class_no));
    setFilteredStudents(filteredStudents);

    const filteredFeeBooks = feesBooks.filter(s => String(s.class) === String(formData.class_no));
    const filteredFeeBook = Array.isArray(filteredFeeBooks)
      ? (filteredFeeBooks[0] || {})
      : (filteredFeeBooks || {});

    setFormData(prev => ({
      ...prev,
      book_paid_amt: prev.book_paid_amt || filteredFeeBook?.book_amt || 0,
      admission_amt: prev.admission_amt || filteredFeeBook?.admin_charge || 0,
      annual_promotion_amt: prev.annual_promotion_amt || filteredFeeBook?.annual_promotion_charge || 0,
      diary_id_tie_belt_amt: prev.diary_id_tie_belt_amt || filteredFeeBook?.diary_id_tie_belt || 0,
    }));
  }, [formData.class_no, students, feesBooks]);

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        id: initialData.id,
        student_id: initialData.student_id || '',
        class_no: initialData.class || '',
        created_at: initialData.created_at?.split("T")[0] || new Date().toISOString().split("T")[0]
      });
    }
  }, [initialData]);

  return (
    <Grid container spacing={2}>
      {message && <Grid item xs={12}><Alert severity="error" onClose={() => setMessage('')}>{message}</Alert></Grid>}
      {/* Dropdowns */}
      <Grid item xs={12} sm={4} style={{width:'110px'}}>
        <TextField
          select fullWidth required
          label="Class"
          name="class_no"
          value={formData.class_no}
          onChange={handleChange}
        >
          {ClassListArray.map(cls => (
            <MenuItem key={cls.value} value={cls.value}>{cls.name}</MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={4} style={{width:'200px'}}>
        <TextField
          select fullWidth required
          label="Student"
          name="student_id"
          value={formData.student_id}
          onChange={handleChange}
          disabled={!formData.class_no}
        >
          {filteredStudents.map(stu => (
            <MenuItem key={stu.id} value={stu.id}>
              {stu.student_name} ({stu.student_father_name})
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={4} style={{width:'110px'}}>
        <TextField
          select fullWidth required
          label="Session"
          name="session"
          value={formData.session}
          onChange={handleChange}
        >
          {sessions.map(sess => (
            <MenuItem key={sess} value={sess}>{sess}</MenuItem>
          ))}
        </TextField>
      </Grid>

      {/* Fee fields */}
      {[
        { label: "Book Amt", name: "book_paid_amt" },
        { label: "Lower T-shirt", name: "lower_tshirt_paid_amt" },
        { label: "Annual Promotion", name: "annual_promotion_amt" },
        { label: "Admission", name: "admission_amt" },
        { label: "Diary/ID/Tie/Belt", name: "diary_id_tie_belt_amt" },
      ].map((field, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <TextField
            label={field.label}
            fullWidth
            type="number"
            name={field.name}
            value={formData[field.name]}
            onChange={handleChange}
            inputProps={{ min: 0, step: '0.01' }}
          />
        </Grid>
      ))}

      <Grid item xs={12} sm={6}>
        <TextField
          name="misc_pending"
          label="Misc Pending"
          type="number"
          fullWidth
          value={formData.misc_pending}
          onChange={handleChange}
          required
          inputProps={{ min: 0, step: '0.01' }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="discount"
          label="Discount"
          type="number"
          fullWidth
          value={formData.discount}
          onChange={handleChange}
          required
          inputProps={{ min: 0, step: '0.01' }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          name="description"
          label="Description"
          fullWidth
          value={formData.description}
          onChange={handleChange}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="created_at"
          label="Created Date"
          type="date"
          fullWidth
          value={formData.created_at}
          onChange={handleChange}
          required
        />
      </Grid>

      <Grid item xs={12}>
        Sum = {Number(formData.lower_tshirt_paid_amt || 0)
          + Number(formData.book_paid_amt || 0)
          + Number(formData.annual_promotion_amt || 0)
          + Number(formData.admission_amt || 0)
          + Number(formData.diary_id_tie_belt_amt || 0)
          - Number(formData.misc_pending || 0)
          - Number(formData.discount || 0)}
      </Grid>

      <Grid item xs={12}>
        <Grid container justifyContent="flex-end">
          <Button variant="contained" onClick={handleSubmit}>
            {formData.id ? "Update" : "Save"}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddEditOtherMiscFee;
